import { Geometry } from '@highimpact-frontend/map-geometry';
import { MapContainer, TileLayer } from 'react-leaflet';
import { useLeaflet } from './useLeaflet';
import LeafletFitBounds from '../leafletFitBounds/LeafletFitBounds';
import ScrollZoomControl from '../coordiantesPicker/ScrollZoomControl';

interface MapDisplayerProps {
  data: Geometry<number, number>[];
}

export function MapDisplayer({ data }: MapDisplayerProps) {
  const geometryElements = useLeaflet(data);

  return (
    <MapContainer
      center={[46.6515, 2.3905]}
      zoom={5}
      style={{ height: '40vh', width: '100%' }}
      zoomControl={true}
      scrollWheelZoom={false}
    >
      <LeafletFitBounds geometries={data} />
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {geometryElements}
      <ScrollZoomControl />
    </MapContainer>
  );
}
